(function($) {

	$.fn.formconfirmsubmit = function(options) {
		// build main options before element iteration
		var opts = $.extend( {}, $.fn.formconfirmsubmit.defaults, options);

		return this.each(function() {
			var $this = $(this);
			// build element specific options
            var eOpts = $.metadata ? $.extend( {}, opts, $this.metadata()) : opts;
            eOpts = $.fn.dataset ? $.extend( {}, eOpts, $this.dataset()) : eOpts;

            $this.submit(function(){
                if($this.data('confirmed')) {
                    return true;
                }
                else {
                    var $dialog = $('<div></div>');
                    $dialog.builddialog({
                        title: eOpts['confirm-title'],
                        'translateText': false,
                        dialogOptions: {
                            close: function() {
                                $this.find('input:submit[disabled],button:submit[disabled]').button('enable');
                            }
                        }

                    });
                    $dialog.builddialog('message', {
                        'text': eOpts['confirm-message'],
                        'translateText': false
                    });
                    $dialog.builddialog('button', {
                        'text': eOpts['confirm-button'],
                        'translateText': false,
                        'click': function(){
                            $this.data('confirmed', true);
                            $dialog.builddialog('close');
                            var parentDialog = $this.data('parentDialog');
                            // if there is a parent dialog need to call jquery submit function to ensure submit handler on this parent is invoked
                            // otherwise must call native javascript submit function
                            if (parentDialog)
                            {
                                $this.submit();
                            }
                            else
                            {
                                $this[0].submit();
                            }
                        }
                    });
                    $dialog.builddialog('button', {
                        'text': eOpts['cancel-button'],
                        'click': function() {
                            $dialog.builddialog('close');
                            $this.find('input:submit[disabled],button:submit[disabled]').button('enable');
                        }
                    });
                    $dialog.builddialog('show');
                    // prevent default submit
                    return false;
                }
            });
        });
	};
	//
	// plugin defaults
	//
	$.fn.formconfirmsubmit.defaults = {
        'cancel-button': 'Cancel'
	};

})(jQuery);